import _styled from "styled-components";
const _excluded = ["children", "canSelect", "toggleSelected", "isSelected", "isHighlightable", "disabled", "tableSize", "style", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { TABLE_ROW_SELECTABLE_CLASSNAME, TABLE_ROW_SELECTED_CLASSNAME, TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
const StyledTableRow = styledC.tr.withConfig({
  displayName: "TableRow__StyledTableRow",
  componentId: "sc-ogi8b7-0"
})(["display:flex;height:", "px;color:", ";min-width:fit-content;", " ", ""], props => props.$height, props => props.disabled ? theme.tokens.colors.text.inactive.value : undefined, props => !props.$isHighlightable || props.disabled ? undefined : "\n  & > [role='cell'] {\n    background-color: ".concat(props.$isSelected ? theme.tokens.colors.background.selected.subtler.value : theme.tokens.colors.background.primary.value, ";\n  }\n  &:hover {\n    & > [role='cell'] {\n      background-color: ").concat(theme.tokens.colors.background.neutral.hover.value, ";\n    }\n  }\n  "), props => !props.$canSelect ? undefined : "\n  cursor: pointer;\n  \n  &:active {\n    & > [role='cell'] {\n      background-color: ".concat(theme.tokens.colors.background.neutral.pressed.value, ";\n    }\n  }\n  "));
var _StyledStyledTableRow = styledC(StyledTableRow).withConfig({
  displayName: "TableRow___StyledStyledTableRow",
  componentId: "sc-ogi8b7-1"
})(["", ""], p => p.$_css);
const TableRow = _ref => {
  let {
      children,
      canSelect,
      toggleSelected,
      isSelected,
      isHighlightable: isHighlightableProp,
      disabled,
      tableSize,
      style,
      className: classNameProp
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const tableSizeTheme = getTableTheme(tableSize);
  const isHighlightable = isHighlightableProp !== undefined ? isHighlightableProp : canSelect;
  const className = useMemo(() => {
    const classNames = [classNameProp];
    if (canSelect) {
      classNames.push(TABLE_ROW_SELECTABLE_CLASSNAME);
    }
    if (isSelected) {
      classNames.push(TABLE_ROW_SELECTED_CLASSNAME);
    }
    return classNames.join(' ');
  }, [canSelect, classNameProp, isSelected]);
  return /*#__PURE__*/React.createElement(_StyledStyledTableRow, _extends({
    onClick: e => !disabled && canSelect && (toggleSelected === null || toggleSelected === void 0 ? void 0 : toggleSelected(!isSelected, e)),
    disabled: disabled,
    $height: tableSizeTheme.rowHeight,
    $canSelect: canSelect,
    $isHighlightable: isHighlightable,
    $isSelected: isSelected,
    className: className
  }, props, {
    $_css: style
  }), children);
};
TableRow.propTypes = {
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  canSelect: PropTypes.bool,
  toggleSelect: PropTypes.func,
  isSelected: PropTypes.bool,
  children: PropTypes.any,
  style: stylePropType
};
export default TableRow;
//# sourceMappingURL=TableRow.js.map